import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_prevent_infinite_loader_gpay_and_paypal_web",
  stages: {
    users_clicks_pay_with_gpay_or_paypal: 1,
    desktop: 2,
    mdot: 3
  },
  defaultStage: 1,
  goals: {
    click_pay_before_3rd_party_payment: 1
  }
});

const { stages, goals } = utils;

export const useTrackInfiniteLoaderBlock = () => {
  const { isDesktop, isMobile } = useProfiler();

  const trackDesktopMdot = useCallback(() => {
    isDesktop() && stages.desktop();
    isMobile() && stages.mdot();
  }, [isDesktop, isMobile]);

  const trackPayNowClickBefore3rdPartyPayment = useCallback(() => {
    goals.click_pay_before_3rd_party_payment();
  }, []);

  return {
    trackDesktopMdot,
    trackPayNowClickBefore3rdPartyPayment
  };
};

export default utils;
